import { render, staticRenderFns } from "./AppBarHelpMenu.vue?vue&type=template&id=3d4018d6"
import script from "./AppBarHelpMenu.vue?vue&type=script&lang=js"
export * from "./AppBarHelpMenu.vue?vue&type=script&lang=js"
import style0 from "./AppBarHelpMenu.vue?vue&type=style&index=0&id=3d4018d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports